<template>
  <video class="video-js"
    data-application-id
    muted
    playsinline
    controlsList="nodownload"
    v-bind="bcAttrs">
  </video>
</template>

<script>
export default {
  props: ['attributes'],
  mounted () {
    this.$loading.withLoading(this.fetchBCScript)()
  },
  computed: {
    bcAttrs () {
      const {value, accountid, autoplay, loop, controls} = this.attributes
      return {
        'data-video-id': value,
        'data-account': accountid,
        'data-player': 'default',
        'data-embed': 'default',
        autoplay: !autoplay || autoplay === 'true',
        loop: !loop || loop === 'true',
        controls: !controls || controls === 'true'
      }
    }
  },
  methods: {
    fetchBCScript () {
      // load brightcove script
      return new Promise((resolve, reject) => {
        var s = document.createElement('script')
        s.src = `//players.brightcove.net/${this.attributes.accountid}/default_default/index.min.js`
        document.body.appendChild(s)
        s.async = true
        s.onload = resolve
        s.onerror = reject
      })
    }
  }
}
</script>

<style lang="scss">
.video-js {
  .vjs-dock-shelf {
    display: none !important;
  }

  .vjs-social-overlay {
    display: none !important;
  }
}
</style>
